import { render, staticRenderFns } from "./AlgoDefinitionForm.vue?vue&type=template&id=b3129744&scoped=true"
import script from "./AlgoDefinitionForm.vue?vue&type=script&lang=js"
export * from "./AlgoDefinitionForm.vue?vue&type=script&lang=js"
import style0 from "./AlgoDefinitionForm.vue?vue&type=style&index=0&id=b3129744&prod&lang=scss&scoped=true"
import style1 from "./AlgoDefinitionForm.vue?vue&type=style&index=1&id=b3129744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3129744",
  null
  
)

export default component.exports